export function isGpcEnabled(): boolean {
  return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
}
